// Constants in case website names change etc.

export const PATIENT_WEBSITE = "https://patients.swyftdoc.com";
export const PROVIDER_WEBSITE = "https://provider.swyftdoc.com";
export const VISIT_PRICE = "$69";
